export default __webpack_public_path__ + "static/media/ic_chat_image_placeholder.f1884dbc.svg";